import React from "react"
import { Icon as ChakraIcon, IconProps } from "@chakra-ui/react"

const MonitorIcon = (props: IconProps) => (
  <ChakraIcon
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <rect x="2" y="3" width="20" height="14" rx="2" />
    <line x1="8" y1="21" x2="16" y2="21" />
    <line x1="12" y1="17" x2="12" y2="21" />
  </ChakraIcon>
)

export default MonitorIcon
